import React from 'react';
import { WidgetSettings } from 'types';

import { RentalAsset } from '@kaltura-ott/tvpil-shared/lib/rhino/data/rental/types';

import DynamicGridViewer from 'components/pages/Grids/DynamicGridViewer/DynamicGridViewer';
import RentalsCardContainer from 'components/widgets/CardView/Rentals/RentalsCardContainer/RentalsCardContainer';
import { WIDGET_TYPE } from 'consts';
import { WidgetProviderData } from 'context/widgetProvider/types';
import WidgetProvider from 'context/widgetProvider/widgetProvider';

interface Props {
  data: WidgetProviderData<RentalAsset>;
  settings: WidgetSettings;
}

function RentalsGridContainer({ settings, data }: Props) {
  return (
    <WidgetProvider<RentalAsset> isGrid type={WIDGET_TYPE.RENTAL} settings={settings} data={data}>
      <DynamicGridViewer<RentalAsset>>
        {({ imageHeight, itemWidth, data: item }) => (
          <RentalsCardContainer imageHeight={imageHeight} itemWidth={itemWidth} item={item} />
        )}
      </DynamicGridViewer>
    </WidgetProvider>
  );
}

export default React.memo(RentalsGridContainer);
